export default "__VITE_ASSET__CMITE6ij__"